<template>
  <div class="xwbk">
    <div class="bt">
      <div
        class="search"
        style="margin-top: 150px"
      >
        <el-input
          placeholder="请输入新闻名称"
          v-model="input3"
          class="input-with-select"
        >
          <el-button
            slot="append"
            @click="serchXW()"
          ><img src="../../assets/xw/xi-magnifier.png" /></el-button>
        </el-input>
      </div>
    </div>
    <div class="rmtj1">
      <div
        v-if="!show"
        class="newLeftFirst"
        v-for="item in searchData"
        @click="ckxxxx1(item.id)"
      >
        <h2>{{ item.name }}</h2>
        <p>{{ item.journalism }}</p>
        <div class="first">
          <p>{{ item.putime }}</p>
          <div class="brows">
            <i class="el-icon-view"></i>
            <p>{{ item.countpublic }}</p>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="!show"
        background
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="rows1"
        layout="total, prev, pager, next"
        :total="datatotal"
        style="text-align: center; margin-top: 20px; margin-bottom: 100px"
      >
      </el-pagination>
      <div
        v-if="show"
        style="width: 950px; margin: auto"
      >
        <el-button
          type="primary"
          style="margin-top: 10px; margin-left: 780px"
          @click="returnLB"
        >返回列表</el-button>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import WOW from "wowjs";
import { selectbrief, selvypublics } from "@/api/patient.js";
export default {
  components: {},
  name: "Home",
  data() {
    return {
      ggData: [],
      // dentity: "新闻资讯",
      page: 1,
      rows: 100000,
      rows1: 6,
      datatotal: 0,
      input3: this.$store.state.scxx,
      searchData: [],
      show: false,
    };
  },
  created() {},
  mounted() {
    this.serchXW();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.serchXW();
    },
    returnLB() {
      this.show = false;
    },
    //搜索新伟
    serchXW() {
      this.show = false;
      let data = new FormData();
      data.append("page", this.page);
      data.append("rows", this.rows1);
      data.append("xueyuan", "倒");
      data.append("school", this.input3);
      // data.append("dentity", this.dentity);
      selvypublics(data).then((res) => {
        this.searchData = res.rows;
        this.datatotal = res.total;
      });
    },
    //查看详细信息
    ckxxxx1(item) {
      this.show = true;
      this.$router.push("/newsItem2/" + `${item}`);
    },
    tiaozhuan() {
      this.$router.push("/");
    },
  },
  computed: {},
  watch: {},
};
</script>
<style scoped>
>>> .el-input__inner {
  height: 50px;
}

.el-menu {
  width: 831px;
}

.el-menu-item {
  /* height: 36px; */
  width: 200px;
}

.el-menu-item {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: #ffffff;
}
</style>
<style lang="scss" scoped>
.xwbk {
  margin: auto;
  width: 70%;
  padding-top: 0px;
  margin: auto;

  .bt {
    padding-top: 70px;
    text-align: center;

    .search {
      display: flex;
      width: 803px;
      height: 50px;
      margin: auto;
      background: #ffffff;
      box-shadow: 0px 3px 11px 0px rgba(0, 0, 0, 0.13);
      border-radius: 5px 5px 5px 5px;
    }

    span {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }

    p {
      margin-top: 5px;
      margin-bottom: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }

  .rmtj1 {
    width: 100%;
    // display: flex;
    margin-top: 50;

    .newLeftFirst {
      width: 800px;
      margin: auto;
      // height: 163px;
      background: #ffffff;
      border-bottom: 1px solid #dedede;

      h2 {
        height: 19px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }

      p {
        height: 17px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
      }

      .first {
        padding-top: 25px;
        display: flex;
        justify-content: space-between;
      }

      .brows {
        display: flex;
        align-items: center;

        p {
          margin-left: 5px;
          display: flex;
          align-items: center;
        }
      }
    }

    .newLeftFirst:hover {
      width: 800px;
      // height: 163px;
      cursor: pointer;
      background: #f6f6f6;
      border-bottom: 1px solid #dedede;

      h2 {
        height: 19px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }

      h2:hover {
        height: 19px;
        font-size: 18px;
        cursor: pointer;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #296cbf;
      }

      p {
        height: 17px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
      }

      .first {
        padding-top: 25px;
        display: flex;
        justify-content: space-between;
      }

      .brows {
        display: flex;
        align-items: center;

        p {
          margin-left: 5px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
